import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
    Grid,
    Button,
    TextField
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {

    },
}));

const Field = props => {
    const { className, data, sendData, filter, ...rest } = props;

    const classes = useStyles();
    const [value, setValue] = React.useState((filter == "assuranceExpired" ? data.dateFinAssurance : ""));

    const handleData = () => {
        if (!value || value.length == 0 || !value.replace(/\s/g, '').length) {
            alert("Donnée incorrect");
            return;
        }

        sendData(value, data._fieldname, data.id);

    }

    const handleValue = ({ target: { value } }) => {
        setValue(value);
    }

    return (
        <Grid container direction="row" spacing={2} justify="flex-start" alignItems="center">
            <Grid item>
                <TextField
                    error={Boolean(data.dateFinAssurance)}
                    value={value}
                    type={data._type}
                    fullWidth
                    onChange={handleValue}
                    size="small"
                    variant="outlined"
                />
            </Grid>
            <Grid item>
                <Button onClick={handleData}
                    variant="contained" color="primary">
                    Mettre à jour
                </Button>
            </Grid>
        </Grid>
    );
};

export default Field;
